import Styles from "./products.module.css";
import { Headline, Image, Attribute, ProHeadline } from "../../subcomponents/subcomponents";
export const Products       = ( props ) => {
    const { products = [], filter } = props;
    const { Products } = Styles;
    return (
        <main className={ Products }>
            {
                products.map(( value, key ) => {
                    const { image, imageTheme, name, nameTheme, link, category } = value;
                    return filter === "All" ? 
                        <Product 
                            image      ={ image      }
                            imageTheme ={ imageTheme }
                            name       ={ name       }
                            nameTheme  ={ nameTheme  }
                            link       ={ link       }
                            key        ={ key        }
                        /> : 
                        filter === category &&
                        <Product
                            image      = { image      }
                            imageTheme = { imageTheme }
                            name       = { name       }
                            nameTheme  = { nameTheme  }
                            link       = { link       }
                            key        = { key        }
                        />;
                })
            }
        </main>
    );
};
export const ProductsHeader = ( props ) => {
    const { setFilter, headlines = [] } = props;
    const { ProductsHeader } = Styles;
    const Attributes = [
        { 
            icon    : <i className="bi bi-globe"></i>, 
            span    : <span></span>, 
            text    : "All", 
            onClick : (e) => setFilter("All") 
        },
        { 
            icon    : <i className="bi bi-terminal-fill" style={{ color: "#9c27b0" }}></i>, 
            span    : <span style={{ backgroundColor: "#9c27b0" }}></span>, 
            text    : "Programming", 
            color   : "#9c27b0", 
            onClick : (e) => setFilter("programming")
        },
        { 
            icon    : <i className="bi bi-grid-fill" style={{ color: "#3f51b5" }}></i>, 
            span    : <span style={{ backgroundColor: "#3f51b5" }}></span>, 
            text    : "Apps", 
            color   : "#3f51b5", 
            onClick : (e) => setFilter("apps") 
        },
        { 
            icon    : <i className="bi bi-person-video3" style={{ color: "#009688" }}></i>, 
            span    : <span style={{ backgroundColor: "#009688" }}></span>, 
            text    : "Courses", 
            color   : "#009688", 
            onClick : (e) => setFilter("courses") 
        },
    ];    
    return (
        <header className={ ProductsHeader }>
            <Attribute   Attributes = { Attributes }/>
            <ProHeadline headlines  = { headlines  }/>
        </header>
    );
};
const Product               = ( props ) => {
    const { image, imageTheme, name, nameTheme, link } = props;
    const { Product } = Styles;
    return (
        <div className={ Product }>
            <Image
                src   = { image      }
                theme = { imageTheme }
                link  = { link       }
            />
            <Headline 
                icon  = { <i className="bi bi-grid-fill"></i> }
                text  = { name                                }
                subIcon = { <i className="bi bi-folder-symlink-fill" style={{ color: "#009688" }}></i> }
                width = { 400                                 }
                theme = { nameTheme                           }
                link  = { link                                }
            />
        </div>
    );
}; 